import request from '@/config/axios'

export const getExpertPage = (params: any) =>
  request.get({ url: '/bosscircle/expert/page', params })
export const getExpert = (id: number) =>
  request.get({ url: '/bosscircle/expert/get', params: { id } })
export const auditExpert = (data: any) => request.put({ url: '/bosscircle/expert/audit', data })
export const updateExpertStatus = (data: any) =>
  request.put({ url: '/bosscircle/expert/status', data })
